import { IconArrowBackUp, IconCircleCheck } from '@tabler/icons-react';
import { ConfirmationModal } from '../common/ConfirmationModal';

interface AdminReviewModalsProps {
  startReviewOpen: boolean;
  approveOpen: boolean;
  rejectOpen: boolean;
  onCloseStartReview: () => void;
  onCloseApprove: () => void;
  onCloseReject: () => void;
  onConfirmStartReview: () => void;
  onConfirmApprove: () => void;
  onConfirmReject: () => void;
}

export function AdminReviewModals({
  startReviewOpen,
  approveOpen,
  rejectOpen,
  onCloseStartReview,
  onCloseApprove,
  onCloseReject,
  onConfirmStartReview,
  onConfirmApprove,
  onConfirmReject
}: Readonly<AdminReviewModalsProps>) {
  return (
    <>
      <ConfirmationModal
        opened={startReviewOpen}
        onClose={onCloseStartReview}
        onCancel={onCloseStartReview}
        onConfirm={() => {
          onCloseStartReview();
          onConfirmStartReview();
        }}
        title="Start review"
        message={
          "You're beginning review on this submission. We'll set the status to in review and prevent further edits " +
          'from the submitter until you approve or reject. Only a rejection lets them edit again.'
        }
        confirmLabel="Start review"
        cancelLabel="Cancel"
        confirmAriaLabel="Confirm start review"
        cancelAriaLabel="Cancel start review"
        severity="info"
        titleOrder={4}
        radius="md"
      />

      <ConfirmationModal
        opened={approveOpen}
        onClose={onCloseApprove}
        onCancel={onCloseApprove}
        onConfirm={() => {
          onCloseApprove();
          onConfirmApprove();
        }}
        title="Approve Report"
        titleIcon={<IconCircleCheck size={22} stroke={1.5} />}
        message={
          "You're signing off that this submission is complete and compliant. We'll set the status to approved and " +
          'prevent further edits.'
        }
        confirmLabel="Approve"
        cancelLabel="Cancel"
        confirmAriaLabel="Confirm approve"
        cancelAriaLabel="Cancel approval"
        severity="info"
        titleOrder={4}
        radius="md"
      />

      <ConfirmationModal
        opened={rejectOpen}
        onClose={onCloseReject}
        onCancel={onCloseReject}
        onConfirm={() => {
          onCloseReject();
          onConfirmReject();
        }}
        title="Reject Report"
        titleIcon={<IconArrowBackUp size={22} stroke={1.5} />}
        message={
          "You're sending this submission back for revision. We'll set the status to rejected and allow the " +
          'submitter to edit and resubmit.'
        }
        confirmLabel="Reject"
        cancelLabel="Cancel"
        confirmAriaLabel="Confirm reject"
        cancelAriaLabel="Cancel rejection"
        severity="info"
        titleOrder={4}
        radius="md"
      />
    </>
  );
}
